import { useTranslation } from "react-i18next";
import { ECONTRACT_STATUS } from "../../../../../../enums";
import { EContractType } from "../../../../../../setup/api/services/contract/models";
import { getMappedContractStatus } from "./constants";
import styles from "./styles.module.scss";

interface StatusPillProps {
  status: ECONTRACT_STATUS;
  contractType?: EContractType;
  customerPartiesCount?: number;
}

const StatusPill = ({
  status,
  contractType,
  customerPartiesCount,
}: StatusPillProps) => {
  const { t } = useTranslation();

  const statusData = getMappedContractStatus(
    status,
    t,
    contractType,
    customerPartiesCount
  );

  if (!statusData) {
    return null;
  }

  return (
    <div
      style={{
        color: statusData.color,
        backgroundColor: statusData.backgroundColor,
      }}
      className={styles.container}>
      {statusData.title}
    </div>
  );
};

export default StatusPill;
